
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexP3ZCGvIiVnhA0G8uwyPcfy0squQ3yvWQQCgdrSE3apwMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/index.vue?macro=true";
import { default as loginUEdi5TVasP1Op681FLARYTP3ZwqA8VemYfRwxkHLHd4Meta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/login.vue?macro=true";
import { default as createxIJAdrALvPwSXjtG6CEB38KAUpxmyp1obRETXgyKmkIMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/create.vue?macro=true";
import { default as forgotPCXMETPQqkDzPp2e69PURLoFqnYR3PmGBIUa4L6MFrgMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/forgot.vue?macro=true";
import { default as reportsbiAK7JOOOJVGTdTHVf_45SfQQf0Rqodq09MlviKxLMlMIMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/reports.vue?macro=true";
import { default as sign_45upeDDLF45JN54eTvmXDCG_FbCZ1iFT55vfxuHugzmeQP0Meta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/sign-up.vue?macro=true";
import { default as insightsYBkxO7R1xSL9ITOFPSsUiYRIzX6737ZluJL8SsCRW3gMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/insights.vue?macro=true";
import { default as new_AR_LJgvkACU9_dvaI0FbMJbC2t8sZaEfZ8AEa69uwIMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/users/new.vue?macro=true";
import { default as newdfm6jgwQ_ZRMD4hzfCjDMG84ifPaXk7Ac4r0c44qzOYMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/makers/new.vue?macro=true";
import { default as newuzIYCv7bHm4E0NgEKebf7P3I2chrhakJcCU_uCl722AMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/orders/new.vue?macro=true";
import { default as _91id_93DyBzecF_3_45uC8xxCsSIOp56lmigexgPqwdQ2oyvn9zcMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/users/[id].vue?macro=true";
import { default as newfpG6SOyPVDHNvgU57_45r_45hUHGCSHNkllONX1UINxkHpoMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/verify/new.vue?macro=true";
import { default as _91id_93QB2e2tzh7JTNs3qiPvbXt3NIOyZQ0pDOS_45mRM6W5n3QMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/makers/[id].vue?macro=true";
import { default as newso_45l6alts9Jpf8dLXhGtfmZrlMjuDvg18vz6jHNVP_45gMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/rewards/new.vue?macro=true";
import { default as index5joa3qj2omZUtkQyZNRPasqAWh1Si9LO_8U_2Cspk08Meta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/users/index.vue?macro=true";
import { default as _91id_93FykPZXlgiVk7BeGELvZl95fmAfkoF5nv9TKWXkz5GEIMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/verify/[id].vue?macro=true";
import { default as integrations5ukv3YuLUkT1vS87ej7kWjSxtY55tGGJN9nXqnH7cIIMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/integrations.vue?macro=true";
import { default as indexB4lrE_45ZmOseaKNwCjEyX_lkn5uStjtCNylrEVXDRUXEMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/makers/index.vue?macro=true";
import { default as index_45tG4XBblBcei_451riCFUQVH9xGNUsrXbHyI2Pm1e2WlYMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/orders/index.vue?macro=true";
import { default as newkDkzkjUTVCuEWsWYkPMLr_k3ZFnTv13GEs_GZmswlJkMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/packages/new.vue?macro=true";
import { default as newGSuibCUx1HsJQW5tdy2M_45X_d3x_GpbjbxWoLFWStjpEMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/products/new.vue?macro=true";
import { default as indexXYpWo9zTWaE_RHdkbwvslaU8uGLFw9ir8pmGmTseRagMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/queues/index.vue?macro=true";
import { default as _91id_93jE2OeZMXXRWfUv_Q8wXmrR3l7hp6xRCVOGbvJpJEuF0Meta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/rewards/[id].vue?macro=true";
import { default as newUqk0RFvI_45_rKjmVwDX9AqvpPYG7zC_455EQ1eG0ZvD4iUMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/settings/new.vue?macro=true";
import { default as new3sX_45QXMOuqNYqwz7295Rdw_O7POY3EbAskvPYN8rMisMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/discounts/new.vue?macro=true";
import { default as _91id_93UfLCw2JjBCe_NYdm0whcxTLBN0QghSWbOeaaadzGBiUMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/packages/[id].vue?macro=true";
import { default as _91id_93F7okvMLoI4u8b0JyJyTZtHKd3o6uTrCV8e274oAZa3AMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/password/[id].vue?macro=true";
import { default as _91id_930_45kiPfAEwfz5Hzsfm1UpRHdkqEVO_45hz4vbHGknIF_45TYMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/products/[id].vue?macro=true";
import { default as indexdSUA_xOow_mC8BYR58_45uhGeGRtzsC4A5vvthdfxsGtsMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/rewards/index.vue?macro=true";
import { default as _91id_932o5kAyqzHR8EpURHxcplpV6ZIHV1z6t5guG9_MVd4EkMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/settings/[id].vue?macro=true";
import { default as _91id_93Owl2SBklcpJAYs2oZuOJhAOfn__Bqf2sXptVvEqvaPEMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/customers/[id].vue?macro=true";
import { default as _91id_93pVBrBeX6zS7kf0495l_dmRmEm4KG209R5aw4hpxoCqwMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/discounts/[id].vue?macro=true";
import { default as downloadwovlrX48SPSdbtuxFWAVanVDsJqlMwgVi8BQiv7l3FgMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/files/download.vue?macro=true";
import { default as indexpDJSgduIC7lfdVH26ZrLotHOPh87wMfMJdQoCYiOAaIMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/packages/index.vue?macro=true";
import { default as index_45sbRxstg2PjG5XK4vgEAUjfSJJqA1HtnHL1uIavsmdwMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/products/index.vue?macro=true";
import { default as indexwUkL2MzDm1GaGzgz_iXqqvaFLiNJgi8DiWWnBvYX62wMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/settings/index.vue?macro=true";
import { default as new_45x6WQ1afKEsftzBaW4CjGpxAIyoj9jCUaAADjJYnbKwMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/cost-centre/new.vue?macro=true";
import { default as indexyrFKRoMzqSOzlCiAWvwo1uKfjrQQCjHDnAXMSOKA0xAMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/customers/index.vue?macro=true";
import { default as indexkb8xIJtg9Da9MHSqY5EfTm9yQjks2TsWXjN6ze6SyeYMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/discounts/index.vue?macro=true";
import { default as _91id_934F6ezIUy8CPam013o1AQB9RiKmuMlGjnFZ1vz4OeUCMMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/cost-centre/[id].vue?macro=true";
import { default as indexMr3fPpKcJ81rvFc2DyhEdbGEe_45S5XVZRerDWiQssPCwMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/cost-centre/index.vue?macro=true";
import { default as indexc4DBMUBA0i3X0X5gK9p8kKY9ujd9ErRMbmN8yevD7TQMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/orders/[id]/index.vue?macro=true";
import { default as newZP5sEEDPOdpNPepM9sfheUyzRoJQwfZRCkLFxud6UNUMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/organisations/new.vue?macro=true";
import { default as _91id_93sAPPhEyM6WXcVtgEBAdmSHkdStyEj9TntvJWYBPLsdQMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/organisations/[id].vue?macro=true";
import { default as indexI2rO8OiSMaaP0RHBthvYEfEzIckE_p_xlARh4f96v_0Meta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/organisations/index.vue?macro=true";
import { default as newc9U_45SuWyLsOiiXGACcFjeb7MNJXMZoWhK3qKu78rcEkMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/maker-categories/new.vue?macro=true";
import { default as _91id_939_ErWdms9nZnXdzRcN1IKKBUegqAIQe6sKFnsSbdi58Meta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/maker-categories/[id].vue?macro=true";
import { default as indexJJFBLtMuZTguZyKmTnc69_hw6OkcPz1MICmEEcM5RZwMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/maker-categories/index.vue?macro=true";
import { default as newYt_zN7sBfSgvTT0njaxR8DhO9hVhWmw0X8tb9CkN6_450Meta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/product-categories/new.vue?macro=true";
import { default as _91id_93ydIiz8NxDVJwgqIps_sjuxvJRotkVX7rSEWivW75toMMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/product-categories/[id].vue?macro=true";
import { default as indexRBBia7q_nJeRVN8q2XXbxf_r7QQW5DMmo5fxj_yc6mIMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/product-categories/index.vue?macro=true";
import { default as _91id_93fWgbCJQCRp1wIdwsSztUfKG2Or2K2L7btDg3UuUgg8UMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/settings/subConfigs/[id].vue?macro=true";
import { default as transaction_45history6vVD7bolmjJTyK39ZqRku605c_45rwLzUxXdlrAMOVXIcMeta } from "/codebuild/output/src566823081/src/and-dine-hub/pages/orders/[id]/transaction-history.vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/login.vue")
  },
  {
    name: "create",
    path: "/create",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/create.vue")
  },
  {
    name: "forgot",
    path: "/forgot",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/forgot.vue")
  },
  {
    name: "reports",
    path: "/reports",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/reports.vue")
  },
  {
    name: "sign-up",
    path: "/sign-up",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/sign-up.vue")
  },
  {
    name: "insights",
    path: "/insights",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/insights.vue")
  },
  {
    name: "users-new",
    path: "/users/new",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/users/new.vue")
  },
  {
    name: "makers-new",
    path: "/makers/new",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/makers/new.vue")
  },
  {
    name: "orders-new",
    path: "/orders/new",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/orders/new.vue")
  },
  {
    name: "users-id",
    path: "/users/:id()",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/users/[id].vue")
  },
  {
    name: "verify-new",
    path: "/verify/new",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/verify/new.vue")
  },
  {
    name: "makers-id",
    path: "/makers/:id()",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/makers/[id].vue")
  },
  {
    name: "rewards-new",
    path: "/rewards/new",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/rewards/new.vue")
  },
  {
    name: "users",
    path: "/users",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/users/index.vue")
  },
  {
    name: "verify-id",
    path: "/verify/:id()",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/verify/[id].vue")
  },
  {
    name: "integrations",
    path: "/integrations",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/integrations.vue")
  },
  {
    name: "makers",
    path: "/makers",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/makers/index.vue")
  },
  {
    name: "orders",
    path: "/orders",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/orders/index.vue")
  },
  {
    name: "packages-new",
    path: "/packages/new",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/packages/new.vue")
  },
  {
    name: "products-new",
    path: "/products/new",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/products/new.vue")
  },
  {
    name: "queues",
    path: "/queues",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/queues/index.vue")
  },
  {
    name: "rewards-id",
    path: "/rewards/:id()",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/rewards/[id].vue")
  },
  {
    name: "settings-new",
    path: "/settings/new",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/settings/new.vue")
  },
  {
    name: "discounts-new",
    path: "/discounts/new",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/discounts/new.vue")
  },
  {
    name: "packages-id",
    path: "/packages/:id()",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/packages/[id].vue")
  },
  {
    name: "password-id",
    path: "/password/:id()",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/password/[id].vue")
  },
  {
    name: "products-id",
    path: "/products/:id()",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/products/[id].vue")
  },
  {
    name: "rewards",
    path: "/rewards",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/rewards/index.vue")
  },
  {
    name: "settings-id",
    path: "/settings/:id()",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/settings/[id].vue")
  },
  {
    name: "customers-id",
    path: "/customers/:id()",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/customers/[id].vue")
  },
  {
    name: "discounts-id",
    path: "/discounts/:id()",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/discounts/[id].vue")
  },
  {
    name: "files-download",
    path: "/files/download",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/files/download.vue")
  },
  {
    name: "packages",
    path: "/packages",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/packages/index.vue")
  },
  {
    name: "products",
    path: "/products",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/products/index.vue")
  },
  {
    name: "settings",
    path: "/settings",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/settings/index.vue")
  },
  {
    name: "cost-centre-new",
    path: "/cost-centre/new",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/cost-centre/new.vue")
  },
  {
    name: "customers",
    path: "/customers",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/customers/index.vue")
  },
  {
    name: "discounts",
    path: "/discounts",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/discounts/index.vue")
  },
  {
    name: "cost-centre-id",
    path: "/cost-centre/:id()",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/cost-centre/[id].vue")
  },
  {
    name: "cost-centre",
    path: "/cost-centre",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/cost-centre/index.vue")
  },
  {
    name: "orders-id",
    path: "/orders/:id()",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/orders/[id]/index.vue")
  },
  {
    name: "organisations-new",
    path: "/organisations/new",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/organisations/new.vue")
  },
  {
    name: "organisations-id",
    path: "/organisations/:id()",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/organisations/[id].vue")
  },
  {
    name: "organisations",
    path: "/organisations",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/organisations/index.vue")
  },
  {
    name: "maker-categories-new",
    path: "/maker-categories/new",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/maker-categories/new.vue")
  },
  {
    name: "maker-categories-id",
    path: "/maker-categories/:id()",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/maker-categories/[id].vue")
  },
  {
    name: "maker-categories",
    path: "/maker-categories",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/maker-categories/index.vue")
  },
  {
    name: "product-categories-new",
    path: "/product-categories/new",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/product-categories/new.vue")
  },
  {
    name: "product-categories-id",
    path: "/product-categories/:id()",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/product-categories/[id].vue")
  },
  {
    name: "product-categories",
    path: "/product-categories",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/product-categories/index.vue")
  },
  {
    name: "settings-subConfigs-id",
    path: "/settings/subConfigs/:id()",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/settings/subConfigs/[id].vue")
  },
  {
    name: "orders-id-transaction-history",
    path: "/orders/:id()/transaction-history",
    component: () => import("/codebuild/output/src566823081/src/and-dine-hub/pages/orders/[id]/transaction-history.vue")
  }
]